export const iconFontAwesomeDesignPen = (
	<i className="fa-solid fa-pen"></i>
);
